export const ADMIN_GET_SLIDERS = 'ADMIN_GET_SLIDERS'
export const ADMIN_ADD_SLIDER = 'ADMIN_ADD_SLIDER'
export const ADMIN_UPDATE_SLIDER = 'ADMIN_UPDATE_SLIDER'
export const ADMIN_DELETE_SLIDER = 'ADMIN_DELETE_SLIDER'
